import Vue from 'vue';
import { format, parseISO } from 'date-fns';

export default function register(): void {
    Vue.filter('date', (value: string | number | Date) => format(
      typeof value === 'string' ? parseISO(value) : value,
    'yyyy-MM-dd HH:mm:ss'
  ));
}
